import React from 'react';
import '../css/Imports.css';

/**
 * Alerta exibido quando há uma importação em andamento.
 *
 * @param {Object}   currentImport - Dados da importação atual (ou null)
 * @param {Function} getTypeLabel  - Converte value → label
 */
const ImportStatusAlert = ({ currentImport, getTypeLabel }) => {
  if (currentImport) {
    const typesDisplay = currentImport.types
      ? (Array.isArray(currentImport.types)
          ? currentImport.types
          : JSON.parse(currentImport.types)
        )
          .map(getTypeLabel)
          .join(', ')
      : '—';

    return (
      <div className="import-status-alert">
        <i className="fa-solid fa-spinner fa-spin mr-2 import-status-alert-icon"></i>
        <strong className="import-status-alert-title">Importação em andamento!</strong>
        <br />
        <span className="import-status-alert-body">Tipos sendo importados:{' '}</span>
        <strong className="import-status-alert-types">{typesDisplay}</strong>
        <br />
        <small className="import-status-alert-time">Iniciada em: {currentImport.import_created}</small>
      </div>
    );
  }

  return (
    <div className="import-status-alert">
      <i className="fa-solid fa-spinner fa-spin mr-2 import-status-alert-icon"></i>
      <strong className="import-status-alert-title">Importação em andamento...</strong>
    </div>
  );
};

export default ImportStatusAlert;
